/**
 * Copy text: the async Clipboard API, then a hidden-textarea execCommand
 * fallback. Resolves false when neither worked (the panel always shows the
 * text, selectable, to copy by hand).
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    const clip = globalThis.navigator?.clipboard;
    if (clip?.writeText) {
      await clip.writeText(text);
      return true;
    }
  } catch {
    // Fall through to the textarea fallback.
  }
  try {
    const doc = globalThis.document;
    if (!doc?.body) return false;
    const ta = doc.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    doc.body.appendChild(ta);
    ta.select();
    const ok = doc.execCommand?.("copy") ?? false;
    doc.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
